import React from 'react'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'

import FormSchemaValidations from './schema-validations'
import FormBase from './form-base'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { setOpenModal } from '../store'
import { useDispatch, useSelector } from 'react-redux'

const Edit = () => {
  const dispatch = useDispatch()
  const { modal } = useSelector(state => state.customerMasterLatitude)

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      type_of_entity: '',
      nit: '',
      nrc: '',
      society: '',
      type_of_establishment: '',
      address: '',
      phone: '',
      economic_activity: '',
      main_admin_name: '',
      main_admin_email: '',
      reset_main_admin_password: '',
      service_to_acquire_digital_signature: [],
      service_to_acquire_digital_invoice: [],
      isActive: false
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(FormSchemaValidations)
  })

  const inputs = {
    type_of_entity: { disabled: true },
    dui: { disabled: true },
    nit: { disabled: true },
  }

  const onSubmit = (data) => {
    console.log(data)
  }
  const handleClose = () => {
    dispatch(setOpenModal({ type: 'edit', open: false }))
  }

  return (
    <Modal
      isOpen={modal.edit.open}
      toggle={ handleClose }
      className="modal-dialog-centered modal-lg"
    >
      <ModalHeader className="bg-transparent" toggle={ handleClose }>
        Editar cliente
      </ModalHeader>

      <FormProvider {...{ handleSubmit, control, reset, setValue, formState: { errors } }} >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <FormBase input={inputs}/>
          </ModalBody>

          <ModalFooter className={'d-flex justify-content-between'}>
            <Button
              type="reset"
              color="secondary"
              onClick={ handleClose }
            >
              Cancelar
            </Button>
            <Button color="primary" type="submit">
              Guardar
            </Button>
          </ModalFooter>
        </Form>
      </FormProvider>
    </Modal>
  )
}

export default Edit
